<script setup lang="ts">
import { computed } from 'vue'
import STHeaderMenu from './STHeaderMenu.vue'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'

const cmsSettings = useCmsConfigStore()
const logoSrc = computed(() => cmsSettings.cmsConfig?.appSettings.logo ?? null)
</script>

<template>
  <div class="st-header-left-controls">
    <RouterLink class="st-header-logo-wrapper" to="/">
      <img v-if="logoSrc" class="st-header-left-controls__logo" :src="logoSrc" />
    </RouterLink>

    <slot name="navigation-menu"></slot>

    <STHeaderMenu />
  </div>
</template>

<style scoped lang="scss">
.st-header-left-controls {
  display: flex;
  flex: 1 0 0;

  &__logo {
    height: 48px;
    margin-right: 8px;
    max-width: 180px;
  }
}

.st-header-logo-wrapper {
  display: flex;
  align-items: center;
}
</style>
